import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "input-form" }
const _hoisted_2 = { class: "input-label" }
const _hoisted_3 = { class: "input-row" }
const _hoisted_4 = { class: "input-box" }
const _hoisted_5 = { class: "suffix-wrap" }
const _hoisted_6 = { class: "input-label" }
const _hoisted_7 = { class: "input-row" }
const _hoisted_8 = { class: "input-box" }
const _hoisted_9 = { class: "suffix-wrap" }

import { ref, reactive, computed, inject } from 'vue';
import { useI18n } from 'vue-i18n'
import md5 from 'js-md5';
import PopupForm from '@/components/PopupForm.vue';
import { useUserStore } from '@/store';


export default {
  __name: 'CreatePassword',
  emits: ['onClose'],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const MyToast = inject('myToast')
const { t } = useI18n()

const userStore = useUserStore()
const showPassword = ref(false);
const form = reactive({
  password: '',
  confirmPwd: '',
});
const confirmDisabled = computed(() => {
  return form.password === '' || form.confirmPwd === '' || form.password !== form.confirmPwd || !/^[A-Za-z0-9]{6,12}$/.test(form.password);
})

const inputBlur = e => {
  let field = e.target.name
  if (field) {
    form[field] = form[field].replace(/ +/g, '');
  }
}

const doConfirm = () => {
  userStore.updateTransactionPwd({ 
    password: md5(form.password),
  }, () => {
    MyToast({ type: 'success', message: t('notify.operateSuccess') });
    emit('onClose');
  })
}

return (_ctx, _cache) => {
  const _component_van_field = _resolveComponent("van-field")
  const _component_van_icon = _resolveComponent("van-icon")
  const _component_van_button = _resolveComponent("van-button")
  const _directive_audio = _resolveDirective("audio")

  return (_openBlock(), _createBlock(PopupForm, {
    title: _ctx.$t('user.withdrawPassword'),
    onOnClose: _cache[4] || (_cache[4] = $event => (emit('onClose')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('label.createPwd')) + ":", 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_van_field, {
              modelValue: form.password,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((form.password) = $event)),
              name: "password",
              class: "input-field",
              placeholder: _ctx.$t('placeholder.pwd'),
              type: !showPassword.value ? 'password' : 'text',
              onBlur: inputBlur,
              clearable: ""
            }, null, 8, ["modelValue", "placeholder", "type"]),
            _createElementVNode("div", _hoisted_5, [
              _withDirectives(_createVNode(_component_van_icon, {
                class: "eye-icon",
                name: !showPassword.value ? 'eye-o' : 'closed-eye',
                onClick: _cache[1] || (_cache[1] = $event => (showPassword.value=!showPassword.value))
              }, null, 8, ["name"]), [
                [_directive_audio]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('label.confirmPwd')) + ":", 1),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_van_field, {
              modelValue: form.confirmPwd,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((form.confirmPwd) = $event)),
              name: "confirmPwd",
              class: "input-field",
              placeholder: _ctx.$t('placeholder.pwd'),
              type: !showPassword.value ? 'password' : 'text',
              onBlur: inputBlur,
              clearable: ""
            }, null, 8, ["modelValue", "placeholder", "type"]),
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createVNode(_component_van_icon, {
                class: "eye-icon",
                name: !showPassword.value ? 'eye-o' : 'closed-eye',
                onClick: _cache[3] || (_cache[3] = $event => (showPassword.value=!showPassword.value))
              }, null, 8, ["name"]), [
                [_directive_audio]
              ])
            ])
          ])
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_van_button, {
          class: "submit-btn",
          disabled: confirmDisabled.value,
          onClick: doConfirm
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.confirm')), 1)
          ]),
          _: 1
        }, 8, ["disabled"])), [
          [_directive_audio]
        ])
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

}